// DONE
import { useContext } from 'react';
import { LanguageContext } from '../../../../../Context/Language.Context';
// import { AnalyticsContext } from '../../../../../Context/AnalyticsContext';
import { RoutingContext } from '../../../../../Context/Routing.Context';
import { SFWBuilderContext } from '../../../../../Context/BuilderContext';
import styles from './ProductHeader.module.css'
import ColorLegend from '../ColorLegend/ColorLegend';
import TheButton from '../../../UI/TheButton/TheButton';
import { logEvent } from '../../../../../Utils/google-analytics';
import { useSearchHook, useSFWBuilderHook } from '../../../../../Hooks/use-context-hooks';

const ProductHeader = ({ product, styleName }) => {
    const { language } = useContext(LanguageContext);
    const { setIsRoutingState, setIsFlashMessageState } = useContext(RoutingContext);
    // const { storeButtonInteraction } = useContext(AnalyticsContext)
    const { isDesktopSearchState, isMobileSearchState, isHomepageSearchState } = useSearchHook();
    const { addItemToBuilderList, removeItemFromBuilderList, builderListItems } = useSFWBuilderHook();
    // const { addItemToBuilderList, removeItemFromBuilderList, builderListItems } = useContext(SFWBuilderContext);
    const { title } = product;
    // const categoryText = language === "EN" ? product.categoryEN : product.categoryFR;
    // const subtitleText = language === "EN" ? product.subtitleEN : product.subtitleFR;
    const subtitleText = product.subtitle;
    let availText;
    if (language === "EN") {
        availText = product.availability;
    } else {
        availText = "Disponible";
        availText = product.availability;
    }



    const handleAddToList = () => {
        const productAlreadyInList = builderListItems.find(item => item._id === product._id);
        let message;
        if (productAlreadyInList) {
            removeItemFromBuilderList(product);
            message = language === "EN" ? `Product ${product.title} removed from list` : `Product ${product.title} retiré de la liste!`;
            setIsFlashMessageState(prevState => ({
                ...prevState,
                show: true,
                message: message,
                iconType: 'subtracted',
                styleName: 'subtracted'
            }))

            // storeButtonInteraction(`click_removed_${product.title}`);
            logEvent('User Interaction', 'Product_Removed_On_Details_Page', `Product Title: ${product.title}`);
        } else {
            addItemToBuilderList(product);
            message = language === "EN" ? `Product ${product.title} added to list` : `Product ${product.title} ajouté à la liste!`;
            setIsFlashMessageState(prevState => ({
                ...prevState,
                show: true,
                message: message,
                iconType: 'checkmark',
                styleName: 'checkmark'
            }))
        }
        setIsRoutingState(prevState => ({ ...prevState, isFlashMessage: message }))
        // logEvent('User Interaction', 'Product_Added_On_Details_Page', `Product Title: ${product.title}`);
        //------------------------------
        // FOR GA4
        // ----------------------------- 
        const getSearchData = () => {
            if (Array.isArray(isHomepageSearchState.isSearchResults) && isHomepageSearchState.isSearchResults.length > 0) {
                return {
                    searchQuery: isHomepageSearchState.isSearchInputValue,
                    searchResultsCount: isHomepageSearchState.isSearchResults.length,
                    searchType: 'Homepage_Search',
                    searchedProduct: product.title,
                    searchedProductCategory: product.category,
                    searchedProductSubcategory: product.subcategory,
                };
            } else if (Array.isArray(isMobileSearchState.isSearchResults) && isMobileSearchState.isSearchResults.length > 0) {
                return {
                    searchQuery: isMobileSearchState.isSearchInputValue,
                    searchResultsCount: isMobileSearchState.isSearchResults.length,
                    searchType: 'Nav_Search',
                    searchedProduct: product.title,
                    searchedProductCategory: product.category,
                    searchedProductSubcategory: product.subcategory,
                };
            } else if (Array.isArray(isDesktopSearchState.isSearchResults) && isDesktopSearchState.isSearchResults.length > 0) {
                return {
                    searchQuery: isDesktopSearchState.isSearchInputValue,
                    searchResultsCount: isDesktopSearchState.isSearchResults.length,
                    searchType: 'Nav_Search',
                    searchedProduct: product.title,
                    searchedProductCategory: product.category,
                    searchedProductSubcategory: product.subcategory,
                };
            }
            return null; // No search data available
        };
        const searchData = getSearchData();
        console.log('search data', searchData)
        // // Only log event once, depending on whether search data exists
        if (searchData) {

            logEvent('SEARCHED_PRODUCT_ADDED', {
                productName: searchData.searchedProduct,
                productCategory: searchData.searchedProductCategory,
                productSubcategory: searchData.searchedProductSubcategory,
                searchType: searchData.searchType,
                searchQuery: searchData.searchQuery,
                searchResultsCount: searchData.searchResultsCount,
            });

        }
        else {
            logEvent('PRODUCT_ADDED', {
                productName: product.title,
                productCategory: product.category,
                productSubcategory: product.subcategory,
            });
        }
    }



    const printStyles = `${styles.productHeaderContainer} ${styles[styleName]}`;
    return (
        <div className={printStyles}>
            <div className={styles.productHeaderTextWrapper}>
                <p className={styles.availabilityText}>{availText}</p>
                <p className={styles.titleText}>{title}</p>
                <p className={styles.subtitleText}>{subtitleText}</p>
            </div>
            <div className={styles.colorLegendWrapper}>
                {/* CONDITION LOGIC GOOD */}
                {/* {product.colourEN.length > 0 ? <ColorLegend product={product} /> : null} */}
                {product.colour.length > 0 ? <ColorLegend product={product} /> : null}
            </div>


            <div className={styles.buttonBoxWrapper} onClick={handleAddToList}>
                {builderListItems.some(item => item._id === product._id) ?
                    <TheButton
                        styleName="blackIconButton"
                        animated="true"
                        // buttonTracking
                        // interactionName={`detailsPage_remove_${product.title}`}
                        buttonIcon="true"
                        iconText={language === "EN" ? "Remove" : "Supprimer"}
                        iconName="subtracted"
                    />
                    :
                    <TheButton
                        animated="true"
                        // buttonTracking
                        // interactionName={`detailsPage_add_${product.title}`}
                        buttonIcon
                        iconText={language === "EN" ? "Add to List" : "Ajouter à la liste"}
                        iconName="add"
                        styleName="redIconButton"
                    />
                }
            </div>
        </div>
    )
}

export default ProductHeader;

